module.exports = __webpack_public_path__ + "static/media/percentage-discount.d10cb436.svg";